"use client"

import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
  title?: string
}

export function ScannerIcon({ className, title }: Props) {
  const { t } = useLingui()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <title>{title ?? ""}</title>
      <path
        d="M9.33398 7.80954V9.33335C9.33398 10.0697 8.73703 10.6667 8.00065 10.6667H2.66732C1.93094 10.6667 1.33398 10.0697 1.33398 9.33335V4.00002C1.33398 3.26364 1.93094 2.66669 2.66732 2.66669H4.19113"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33398 5.77118L10.1052 1.99994"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.667 5.33337V1.33337H6.66699"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
